"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var TriggerClass_1 = __importDefault(require("./TriggerClass"));
var Delay = /** @class */ (function (_super) {
    __extends(Delay, _super);
    function Delay(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    Delay.prototype.init = function (actionCallback) {
        var _this = this;
        if (this.hasRendered)
            return;
        setTimeout(function () {
            if (_this.isDeprecated)
                return;
            actionCallback();
            _this.hasRendered = true;
        }, this.value * 1000);
    };
    Delay.prototype.toString = function () {
        return "trigger delay for ".concat(this.value, "s");
    };
    return Delay;
}(TriggerClass_1.default));
exports.default = Delay;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRGVsYXkuanMiLCJzb3VyY2VSb290Ijoic3JjLyIsInNvdXJjZXMiOlsic3JjL2xpYi9zZXJ2aWNlcy90cmlnZ2Vycy9EZWxheS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLGdFQUE0RDtBQUU1RDtJQUFtQyx5QkFBWTtJQUczQyxlQUFZLEtBQWE7UUFBekIsWUFDSSxpQkFBTyxTQUVWO1FBREcsS0FBSSxDQUFDLEtBQUssR0FBRyxLQUFLLENBQUE7O0lBQ3RCLENBQUM7SUFFRCxvQkFBSSxHQUFKLFVBQUssY0FBNkI7UUFBbEMsaUJBT0M7UUFORyxJQUFJLElBQUksQ0FBQyxXQUFXO1lBQUUsT0FBTTtRQUM1QixVQUFVLENBQUM7WUFDUCxJQUFJLEtBQUksQ0FBQyxZQUFZO2dCQUFFLE9BQU07WUFDN0IsY0FBYyxFQUFFLENBQUE7WUFDaEIsS0FBSSxDQUFDLFdBQVcsR0FBRyxJQUFJLENBQUE7UUFDM0IsQ0FBQyxFQUFFLElBQUksQ0FBQyxLQUFLLEdBQUcsSUFBSSxDQUFDLENBQUE7SUFDekIsQ0FBQztJQUVELHdCQUFRLEdBQVI7UUFDSSxPQUFPLDRCQUFxQixJQUFJLENBQUMsS0FBSyxNQUFHLENBQUE7SUFDN0MsQ0FBQztJQUNMLFlBQUM7QUFBRCxDQUFDLEFBcEJELENBQW1DLHNCQUFZLEdBb0I5QyJ9